






































import {mapActions} from 'vuex';
import Vue from 'vue';
import {AdminMessageType} from '@/store/modules/Conversations/state';
import {LocaleMessage} from 'vue-i18n';
import {AdminMessageCreation} from '#/Conversations';
import {VForm} from '#/index';
import RichTextEditor from '@/components/admin/RichTextEditor.vue';

interface ComponentData {
  items: {
    text: string;
    value: AdminMessageType;
  }[];
  message: AdminMessageCreation;
  rules: {
    content: ((v: string) => boolean | LocaleMessage)[];
    title: ((v: string) => boolean | LocaleMessage)[];
    type: ((v: number) => boolean | LocaleMessage)[];
  };
}

export default Vue.extend({
  name: 'AdminMessages',

  components: {RichTextEditor},

  data: function (): ComponentData {
    return {
      items: [
        {
          text: this.$t('admin.message.form.types.POPUP') as string,
          value: AdminMessageType.POPUP,
        },
        {
          text: this.$t('admin.message.form.types.EULA') as string,
          value: AdminMessageType.EULA,
        },
        {
          text: this.$t('admin.message.form.types.MESSAGE') as string,
          value: AdminMessageType.MESSAGE,
        },
      ],

      message: {
        content: '',
        title: '',
        type: 0,
      },

      rules: {
        content: [
          v => !!v || this.$t('admin.message.form.errors.required'),
          v => {
            // @ts-ignore
            if (this.isPopPup) {
              return v?.length <= 300 || this.$t('admin.message.form.errors.maxSize', {size: '300'});
            }
            return true;
          },
        ],
        title: [
          v => !!v || this.$t('admin.message.form.errors.required'),
          v => v?.length <= 255 || this.$t('admin.message.form.errors.maxSize', {size: '255'}),
        ],
        type: [
          v => !!v || this.$t('admin.message.form.errors.required'),
        ],
      },
    };
  },

  computed: {
    isPopPup(): boolean {
      return this.message.type === AdminMessageType.POPUP;
    },
    isEULA(): boolean {
      return this.message.type === AdminMessageType.EULA;
    },
    isMessage(): boolean {
      return this.message.type === AdminMessageType.EULA;
    },
  },

  watch: {
    'message.type': function () {
      this.message.title = this.isEULA ? this.$t('admin.message.form.defaultValues.title') as string : '';
      this.message.content = this.isEULA ? this.$t('admin.message.form.defaultValues.content') as string : '';

      (this.$refs.form as VForm).resetValidation();
    },
  },

  created() {
    this.updatePageTitle(this.$t('template.sideMenu.adminMessages'));
  },

  methods: {
    ...mapActions([
      'createAdminMessage',
      'updatePageTitle',
    ]),
    onSubmit(): void {
      if ((this.$refs.form as VForm).validate()) {
        this.createAdminMessage(this.message)
            .then(() => {
              this.resetForm(this.$refs.form as VForm);
            });
      }
    },
    resetForm(form: VForm): void {
      form.resetValidation();
      this.message.type = 0;
      this.message.title = '';
      this.message.content = '';
    },
  },
});
